<split-filter-dropdown 
    [field]="field" 
    [data]="data" 
    [label]="label"
    [key]="key"
    (onSearchEvent)="onSearchDropdownChange($event)"
    (onFilterEvent)="this.onFilterEvent.emit($event)"
></split-filter-dropdown>